import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getImportMetadata } from 'api/Admin/PatientImports';

export const useGetImportMetadata = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['import-metadata', ...dependencies], () => getImportMetadata(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 5000,
    ...options
  });
};
